import { atomWithStorage, createJSONStorage } from "jotai/utils";

// Stores the dash stack chat sidebar open state.
// Use session storage to persist the state across sessions e.g. closing in tab A should not close it in tab B.
export const stackChatSidebarOpenAtom = atomWithStorage<boolean>(
  "stackChatSidebarOpen",
  true,
  createJSONStorage(() => sessionStorage),
  { getOnInit: true },
);
